import styled from "styled-components";

export const Title = () => <StyledTitle>Дошки оголошень </StyledTitle>;

const StyledTitle = styled.div`
  font-size: 18px;
  line-height: 22.79px;
  letter-spacing: 0.02em;
  font-weight: var(--font-weight-200);
  color: var(--color-2);
  margin-bottom: 15px;
`;
